import { render } from "./SurveyActionButtons.vue?vue&type=template&id=b1b437f6&scoped=true"
import script from "./SurveyActionButtons.vue?vue&type=script&lang=js"
export * from "./SurveyActionButtons.vue?vue&type=script&lang=js"

import "./SurveyActionButtons.vue?vue&type=style&index=0&id=b1b437f6&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b437f6"]])

export default __exports__